import { takeLatest, call, put } from 'redux-saga/effects';
import { RESET_PASSWORD_REQUEST } from '../types/AuthTypes';
import axios from 'axios';
import {
  resetPasswordFailure,
  resetPasswordSuccess,
} from '../actions/authActions';
import axiosInstance from '../../instance/AxiosInstance';
function* handleResetPassword(action) {
  try {
    const { email, newPassword } = action.payload;
    const response = yield call(axiosInstance.post, '/auth/forgotpassword', {
      email,
      password: newPassword,
    });
    yield put(resetPasswordSuccess(response.data.message));
  } catch (error) {
    yield put(
      resetPasswordFailure(error.response?.data?.message || error.message)
    );
  }
}
export function* watchResetPassword() {
  yield takeLatest(RESET_PASSWORD_REQUEST, handleResetPassword);
}
